import React from 'react'
import ReactCountryFlag from 'react-country-flag'
import COUNTRIES_EN from 'world_countries_lists/data/countries/en/world.json'

// Common destinations first, as CountryDropDown does (France, Belgium, Switzerland, Canada, Tunisia, Qatar).
const COUNTRIES_FIRST = [250, 56, 756, 124, 788, 634]

// UK home nations compete under their own flag but are not ISO 3166-1 countries, so world.json lacks them.
// The flag CDN (lipis/flag-icons) serves these codes. Athletes only: an event's country stays ISO.
export const UK_NATIONS = [
    { alpha2: 'gb-eng', name: 'England' },
    { alpha2: 'gb-sct', name: 'Scotland' },
    { alpha2: 'gb-wls', name: 'Wales' },
    { alpha2: 'gb-nir', name: 'Northern Ireland' },
]

/** antd Select options of the given countries — value: the English name, `searchLabel` for `optionFilterProp`. */
const toOptions = (countries) =>
    [...countries]
        .sort((a, b) => {
            const ia = COUNTRIES_FIRST.indexOf(a.id)
            const ib = COUNTRIES_FIRST.indexOf(b.id)
            if (ia > -1 && ib > -1) return ia - ib
            if (ia > -1) return -1
            if (ib > -1) return 1
            return a.name.localeCompare(b.name)
        })
        .map((country) => ({
            value: country.name,
            searchLabel: country.name,
            label: (
                <span className="inline-flex items-center gap-2">
                    <ReactCountryFlag countryCode={country.alpha2} svg style={{ width: 18, height: 12 }} />
                    {country.name}
                </span>
            ),
        }))

/** every ISO country — the event country filter */
export const COUNTRY_OPTIONS = toOptions(COUNTRIES_EN)

/** an athlete's country: ISO countries plus the UK home nations */
export const ATHLETE_COUNTRY_OPTIONS = toOptions([...COUNTRIES_EN, ...UK_NATIONS])
